import { ProcessGroupFilterId, PROCESS_GROUPS } from '@app/pages/admin/orchestration-process-groups.util';
import { ScheduleGanttWindowHours } from '@app/pages/admin/components/subscription-schedule-gantt/subscription-schedule-gantt.util';

export type SubscriptionsCatalogView = 'gantt' | 'subscriptions';

export interface SubscriptionsCatalogQuery {
  view: SubscriptionsCatalogView;
  windowHours: ScheduleGanttWindowHours;
  module: ProcessGroupFilterId;
}

const MODULE_IDS = new Set<string>(['all', ...PROCESS_GROUPS.map(group => group.id)]);

type QueryParamReader = {
  get(name: string): string | null;
};

export function parseSubscriptionsCatalogQuery(params: QueryParamReader): SubscriptionsCatalogQuery {
  const viewRaw = params.get('view');
  const view: SubscriptionsCatalogView = viewRaw === 'subscriptions' ? 'subscriptions' : 'gantt';
  const windowRaw = params.get('window');
  const windowHours: ScheduleGanttWindowHours = windowRaw === '7d' ? 168 : 24;
  const moduleRaw = params.get('module')?.trim() ?? '';
  const module: ProcessGroupFilterId = MODULE_IDS.has(moduleRaw)
    ? moduleRaw as ProcessGroupFilterId
    : 'all';
  return { view, windowHours, module };
}

export function serializeSubscriptionsCatalogQuery(
  query: SubscriptionsCatalogQuery,
): Record<string, string | null> {
  return {
    view: query.view === 'gantt' ? null : 'subscriptions',
    window: query.windowHours === 168 ? '7d' : null,
    module: query.module === 'all' ? null : query.module,
  };
}

export function subscriptionsCatalogQueryEqual(
  left: SubscriptionsCatalogQuery,
  right: SubscriptionsCatalogQuery,
): boolean {
  return left.view === right.view
    && left.windowHours === right.windowHours
    && left.module === right.module;
}
